import PropTypes from 'prop-types';
import { Box, Flex, Text, Tooltip } from '@radix-ui/themes';
import { BROADCAST_DOT_COLORS } from '../../../../campaigns/components/CampaignsTable/CalendarView/helpers.js';
import styles from '../../../../campaigns/components/CampaignsTable/CalendarView/CalendarView.module.css';

const EMPTY_LIST = [];
const noop = () => {};

export default function BroadcastDayCell({
  dayNumber,
  broadcasts = EMPTY_LIST,
  isToday = false,
  isPastDay = false,
  onBroadcastClick = noop,
}) {
  const getBroadcastIcon = broadcastType => {
    switch (broadcastType) {
      case 'sms':
        return 'fa-regular fa-message-sms';
      case 'email':
        return 'fa-regular fa-envelope';
      default:
        return 'fa-regular fa-paper-plane';
    }
  };

  return (
    <Box
      className={`${styles.dayCell} ${isToday ? styles.dayCellToday : ''} ${
        isPastDay ? styles.dayCellPast : ''
      }`}
    >
      <Text className={styles.dayCellNumber} size="1" weight="medium">
        {dayNumber}
      </Text>
      <Flex direction="column" gap="1" className={styles.dayCellItems}>
        {broadcasts.slice(0, 3).map((broadcast, index) => (
          <Tooltip
            key={`broadcast-${broadcast.uuid}-${index}`}
            content={`${
              broadcast.broadcastTypeLabel
            }: ${broadcast.contentPreview || ''}`}
          >
            <Flex
              className={`${styles.dayCellItem}${
                broadcast.status === 'draft'
                  ? ` ${styles.dayCellItemDraft}`
                  : ''
              }`}
              align="center"
              gap="1"
              onClick={e => {
                e.stopPropagation();
                onBroadcastClick(broadcast);
              }}
              style={{
                borderLeft: `2px solid ${
                  BROADCAST_DOT_COLORS[broadcast.status]
                }`,
              }}
            >
              <i
                className={`${getBroadcastIcon(broadcast.broadcastType)} ${
                  styles.dayCellItemIcon
                }`}
              />
              <Text size="1" className={styles.dayCellItemText}>
                {(broadcast.contentPreview || '').length > 12
                  ? `${(broadcast.contentPreview || '').slice(0, 10)}…`
                  : broadcast.contentPreview || broadcast.broadcastTypeLabel}
              </Text>
            </Flex>
          </Tooltip>
        ))}
        {broadcasts.length > 3 && (
          <Text size="1" className={styles.dayCellMore}>
            +{broadcasts.length - 3} more
          </Text>
        )}
      </Flex>
    </Box>
  );
}

BroadcastDayCell.propTypes = {
  dayNumber: PropTypes.number.isRequired,
  broadcasts: PropTypes.array,
  isToday: PropTypes.bool,
  isPastDay: PropTypes.bool,
  onBroadcastClick: PropTypes.func,
};
